import { InjectionToken } from '@angular/core';

export enum Application {
  ClientGateway,
  Latam,
}

export const APPLICATION = new InjectionToken<Application>(
  'Current application'
);
